"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSurface = updateSurface;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const numbers_1 = require("../../helpers/numbers");
/**
 * Updates the printable surface in place using the given template
 */
function updateSurface(_ref) {
  let {
    printable,
    newTemplate,
    printableGroupType,
    interiorPageCount
  } = _ref;
  var _a, _b;
  let surface = (0, lodash_clonedeep_1.default)(newTemplate.surface);
  if (printableGroupType === 'cover' && newTemplate.coverSurfaces) {
    const coverSurface = newTemplate.coverSurfaces.find(coverSurf => coverSurf.pageCount && (0, numbers_1.inRange)(interiorPageCount, coverSurf.pageCount.min, coverSurf.pageCount.max));
    surface = (0, lodash_clonedeep_1.default)(coverSurface) || printable.surface;
  } else if (printableGroupType === 'wooden-box' && ((_a = newTemplate.woodenBox) === null || _a === void 0 ? void 0 : _a.surface)) {
    surface = (0, lodash_clonedeep_1.default)((_b = newTemplate.woodenBox) === null || _b === void 0 ? void 0 : _b.surface) || printable.surface;
  }
  return surface;
}